import React from 'react';
import { motion } from 'framer-motion';
import { Wrench, Clock } from 'lucide-react';
export function MaintenancePage() {
  return <div className="min-h-screen bg-background text-textMain flex items-center justify-center p-6" data-id="element-6531">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="max-w-md w-full bg-surface border border-border rounded-2xl p-8 text-center" data-id="element-6532">
        <div className="w-16 h-16 rounded-full bg-amber-500/10 text-amber-500 flex items-center justify-center mx-auto mb-6" data-id="element-6533">
          <Wrench className="w-8 h-8" data-id="element-6534" />
        </div>
        <h1 className="text-2xl font-bold mb-2" data-id="element-6535">Scheduled Maintenance</h1>
        <p className="text-textMuted mb-8" data-id="element-6536">
          Booker is currently undergoing scheduled maintenance to improve
          performance and reliability. We apologize for the inconvenience.
        </p>
        <div className="bg-background border border-border rounded-lg p-4 flex items-center gap-4 text-left" data-id="element-6537">
          <div className="w-10 h-10 rounded-full bg-surface border border-border flex items-center justify-center shrink-0" data-id="element-6538">
            <Clock className="w-5 h-5 text-textMuted" data-id="element-6539" />
          </div>
          <div data-id="element-6540">
            <div className="text-sm font-medium" data-id="element-6541">Estimated Completion</div>
            <div className="text-xs text-textMuted mt-0.5" data-id="element-6542">
              April 6, 2026 at 4:00 AM PST
            </div>
          </div>
        </div>
      </motion.div>
    </div>;
}